import { Colors, Fonts, ContentSpacing } from 'elc-base-theme';

export const selectedSizeBoxTheme = `
    background-color: ${Colors.primary900};
    color: ${Colors.white};
`;

export const sizeBoxTheme = `
    border-color: ${Colors.black};
`;

export const selectedShadeImageTheme = `
    border-color: ${Colors.black};
    box-shadow: 0 0 1px 1px ${Colors.black};
`;

export const shadeImageTheme = `
    border-color: ${Colors.white};

    &:hover {
        box-shadow: 0 1px ${Colors.white};
        border-color: ${Colors.black};
    }
`;

export const sizePickerLabelTheme = `
    color: ${Colors.blackDisabledEmphasis};
`;

export const anchorTheme = `
    cursor: pointer;
    text-decoration: underline;
    font-family: ${Fonts.roboto};
    font-size: ${ContentSpacing.space12};
`;

export const anchorUppercaseTheme = `
    text-transform: uppercase;
    font-weight: 700;
    ${anchorTheme};
`;

export const anchorLowercaseTheme = `
    text-transform: lowercase;
    ${anchorTheme};
`;

export const secondaryTextTheme = `
    font-size: ${ContentSpacing.space12};
    font-family: ${Fonts.roboto};
    color: ${Colors.primary700};
    text-transform: lowercase;
    vertical-align: middle;
`;

export const borderTopTheme = `
    border-top: 1px solid ${Colors.primary400};
`;

export const borderBottomTheme = `
    border-bottom: 1px solid ${Colors.primary400};
`;

export const MainColumnTheme = `
    background: ${Colors.primary100};
`;

export const inputBorderTheme = `	
    border-radius: 0;
    border: 1px solid ${Colors.primary400};		
`;

export const SideColumnTheme = `
    background: ${Colors.white};
    box-shadow: ${ContentSpacing.space4} 0 ${ContentSpacing.space4} 0 ${Colors.blackLightEmphasis};
`;
export const StickyRowTheme = `
    background: ${Colors.white};
    box-shadow: 0 1px 1px 0 ${Colors.blackLightEmphasis};
`;

export const backgroundWhiteTheme = `
    background: ${Colors.white};
`;

export const backgroundOverlay = `
    background: rgba(0, 0, 0, 0.4);
`;

export const iconStrokeTheme = `
    stroke: ${Colors.primary700};
    stroke-width: 2px;
`;

export const columnHeadingTheme = `
    text-transform: none;
    font-weight: bold;
    font-size: ${ContentSpacing.space16};
    letter-spacing: normal;
`;

export const filterHeadingTheme = `
    font-weight: normal;
    text-transform: uppercase;
`;

export const clearButtonTheme = `
    background: none;
    border: none;
    color: ${Colors.blackLightEmphasis};
    font-family: ${Fonts.robotoMedium};
    font-size: ${ContentSpacing.space20};
`;

export const customInputTheme = `
    font-size: ${ContentSpacing.space24};
    border: 0;
    color: ${Colors.primary800};
    font-family: ${Fonts.roboto};
    ::placeholder {
        color: ${Colors.blackLightEmphasis};
        font-family: ${Fonts.robotoMedium};
    }
`;

export const inputBorderMobileTheme = `
    border-radius: 0;
    border-width: 1px 0;		
    border-style: solid;		
    border-color: ${Colors.primary500};		
`;

export const clearButtonThemeMobile = `
    background: none;
    border: none;
    color: ${Colors.blackMediumEmphasis};
    font-family: ${Fonts.robotoMedium};
    font-size: 13px;
    letter-spacing: 0.${ContentSpacing.space16};
`;

export const customInputThemeMobile = `
    font-size: 13px;
    border: 0;
    color: ${Colors.primary700};
    font-family: ${Fonts.robotoMedium};
    letter-spacing: 0.${ContentSpacing.space16};
    line-height: ${ContentSpacing.space20};
    ::placeholder {
        color: ${Colors.primary700};
        font-family: ${Fonts.robotoMedium};
    }
`;
export const noResultsText = `
    color: ${Colors.black};
    font-family: ${Fonts.roboto};
    font-size: 14px;
    letter-spacing: 0.25px;
`;
export const noResultsTextMobile = `
    color: ${Colors.black};
    font-family: ${Fonts.roboto};
    font-size: ${ContentSpacing.space12};
    line-height: ${ContentSpacing.space16};
`;
export const bestSellerTitle = `
    font-family: ${Fonts.robotoMedium};
    font-size: ${ContentSpacing.space16};
    line-height: ${ContentSpacing.space16};
    letter-spacing: 0.15px;
`;
export const bestSellerTitleMobile = `
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0;
`;

export const fillSearchMagnifier = `
    fill: ${Colors.primary600};
`;

export const suggestionText = `
    font-size: 14px;
    font-family:${Fonts.robotoMedium};
    white-space: nowrap;
    text-overflow: ellipsis;
    text-decoration: none;
`;
export const suggestionWrapper = `
    border-bottom: 0.5px solid #979797;
`;

export const allResultsButton = `
    font-family: ${Fonts.robotoMedium};
    font-size: ${ContentSpacing.space16};
    letter-spacing: 1px;
    line-height: ${ContentSpacing.space24};
`;

export const backgroundResultsButton = `
    background: ${Colors.white};
    box-shadow: 0 -${ContentSpacing.space4} ${ContentSpacing.space8} 0 rgba(0, 0, 0, 0.2);
`;

export const searchResultsHeader = `
    font-weight: bold;
`;

export const fontBold = `
    font-weight: bold;
`;

export const headerLabel = `
    color: ${Colors.primary800};
    font-family: ${Fonts.robotoMedium};
    font-size: 16px;
    letter-spacing: 0.15px;
    line-height: ${ContentSpacing.space20};
`;

export const filtersTitleLabel = `
    color: ${Colors.primary800};
    font-family: ${Fonts.robotoMedium};
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 0.18px;
    line-height: 42px;
    text-transform: uppercase;
`;

export const dropdownSortLabel = `
    color: ${Colors.primary800};
    font-family: ${Fonts.roboto};
    font-size: 20px;
    letter-spacing: 0.${ContentSpacing.space24};
    line-height: ${ContentSpacing.space32};
`;

export const mobileSortLabel = `
    font-size: 14px;
    letter-spacing: 0.${ContentSpacing.space24};
    line-height: ${ContentSpacing.space20};
    ::placeholder {
        color: ${Colors.primary800};
        font-family: ${Fonts.roboto};
        text-align: center;
    }
`;

export const MobileSelectTheme = `
    font-family: ${Fonts.robotoMedium};
    font-size: 14px;
    color:  ${Colors.primary700};
`;

export const mobileOption = `
    cursor: pointer;
    color: ${Colors.black};
    font-family: ${Fonts.robotoMedium};
    font-size: ${ContentSpacing.space16};
    height: ${ContentSpacing.space16};
    letter-spacing: 0.15px;
    line-height: ${ContentSpacing.space16};
`;

export const mobileOptionLabel = `
    background: ${Colors.primary300};
`;

export const removeIconFilter = `
    stroke: ${Colors.primary600};
`;

export const filterValue = `
    color: ${Colors.primary600};
`;

export const clearFilterButtonMobile = `
    background: transparent;
    color: ${Colors.black};
    text-decoration: underline;
`;

export const clearFilterButtonDesktop = `
    background: ${Colors.black};;
    color: ${Colors.white};
    text-decoration: none;
`;

export const filtersCount = `
    letter-spacing: 0.24px;
    line-height: ${ContentSpacing.space20};
    font-size: 14px;
`;

export const searchTab = `
    background-color: transparent;
    color: ${Colors.black};
`;

export const transparentButton = `
    border: none;
    background-color: transparent;
`;
